import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import '../css/topperSlide.css';
import defaultImage from '../images/empty_box.png'; // Ensure the path is correct
import topper1 from "../images/topper_1_aanya.jpg";
import topper2 from "../images/topper_2_abhishek.jpg";
import topper3 from "../images/topper_3_khushi.jpg";

import TopperSliderForm from "./topperSliderForm";

function TopperSlideComponent(props) {
    const {
        flgEditPlay = "edit",
        examId = 0,
        clsId = 0,
        sectionId = 0,
        ptmId = 0,
        exam = "",
        cls = "cls",
        section = "",
        basePathPtmToppers,
        lstTopper
    } = props;

    const [flgTopperSlideFormVisible, setFlgTopperSlideFormVisible] = useState(false);
    const [topperRank, setTopperRank] = useState(0);
    const [topperObj, setTopperObj] = useState(null);
    const [lstPtmTopper, setLstPtmTopper] = useState([]);
    const [basePath, setBasePath] = useState("");

    // States for the three students by rank
    const [student1, setStudent1] = useState(null);
    const [student2, setStudent2] = useState(null);
    const [student3, setStudent3] = useState(null);

    useEffect(() => {
        // console.log("TopperSlideComponent called");
        // console.log("flgEditPlay:", flgEditPlay);
        // console.log("examId:", examId);
        // console.log("clsId:", clsId);
        // console.log("sectionId:", sectionId);
        // console.log("ptmId:", ptmId);
        // console.log("exam:", exam);
        // console.log("cls:", cls);
        // console.log("section:", section);
        // console.log("basePathPtmToppers:", basePathPtmToppers);
        // console.log("lstTopper:", lstTopper);
    }, [flgEditPlay, examId, clsId, sectionId, ptmId, exam, cls, section, basePathPtmToppers, lstTopper]);


    useEffect(() => {
        // Set base path and list of toppers
        setLstPtmTopper(lstTopper);
        setBasePath(`https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=${basePathPtmToppers}`);

        // Find students by rank and save them in respective states

        if (!!lstTopper && lstTopper.length) {
            setStudent1(findStudentByRank(1, lstTopper));
            setStudent2(findStudentByRank(2, lstTopper));
            setStudent3(findStudentByRank(3, lstTopper));
        } else {
            setStudent1(null);
            setStudent2(null);
            setStudent3(null);
        }
    }, [lstTopper, basePathPtmToppers]);

    const findStudentByRank = (rank, pLstTopper) => {
        // console.log('findStudentByRank called, rank', rank, ', pLstTopper', pLstTopper);
        const studentFound = pLstTopper.find(student => student.topperRank === rank) || null;
        return studentFound;
    };

    const handleEditImage = async (pTopper, pTopperRank) => {

        if (flgEditPlay !== "edit") {
            return;
        }
        if (!examId) {
            toast.warn("please select exam");
            return;
        }
        let tempObj = {};
        if (pTopper) {
            tempObj = {
                student: pTopper.student,
                studentId: pTopper.studentId,
                score: pTopper.score,
                imgPath: basePath + "/" + pTopper.imgPath
            };
        }
        await setTopperObj(tempObj);
        await setTopperRank(pTopperRank);
        setFlgTopperSlideFormVisible(true);
    };

    const closeSlider = () => {
        setFlgTopperSlideFormVisible(false);
    };

    return (
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 central-section" style={{ marginTop: "20px", pointerEvents: (flgEditPlay === "edit") ? "auto" : "none" }}>
            <div className="left-space"></div>
            <div className="main-section">
                {/* Left Box */}
                <div
                    className="left-box"
                    onClick={() => handleEditImage(student2, 2)}
                    style={{ position: "relative" }}
                >
                    <div className="content-div">
                        <div className="left-content">
                            <div className="col-sm-12 text-center" style={{ color: '#fff', fontSize: '3rem' }}>II</div>
                            {student2?.imgPath ? (
                                <img
                                    src={basePath + "/" + student2.imgPath}
                                    alt="Student 2"
                                    className="student-image-2"
                                />
                            ) : (
                                <img src={topper2} alt="Empty" className="student-image-2" />
                            )}
                            <div className="score-box-left">
                                <div style={{ fontSize: "2rem", fontWeight: "bold" }}>
                                    {/* {student2?.student} - {student2?.score}% */}
                                    {`${student2?.student ?? "abhishek"} - ${student2?.score ?? 89}%`}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="spacer"></div>

                {/* Center Box */}
                <div
                    className="center-box"
                    onClick={() => handleEditImage(student1, 1)}
                >
                    <div className="content-div">
                        <div className="center-content">
                            <div className="col-sm-12 text-center" style={{ color: '#fff', fontSize: '3rem' }}>I</div>
                            {student1?.imgPath ? (
                                <img
                                    src={basePath + "/" + student1.imgPath}
                                    alt="Student 1"
                                    className="student-image-1"
                                />
                            ) : (
                                <img src={topper1} alt="Empty" className="student-image-1" />
                            )}
                            <div className="score-box-center">
                                <div style={{ fontSize: "2rem", fontWeight: "bold" }}>
                                    {/* {student1?.student} - {student1?.score}% */}
                                    {`${student1?.student ?? "aanya"} - ${student1?.score ?? 96}%`}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="spacer"></div>

                {/* Right Box */}
                <div
                    className="right-box"
                    onClick={() => handleEditImage(student3, 3)}
                >
                    <div className="content-div">
                        <div className="right-content">
                            <div className="col-sm-12 text-center" style={{ color: '#fff', fontSize: '3rem' }}>III</div>
                            {student3?.imgPath ? (
                                <img
                                    src={basePath + "/" + student3.imgPath}
                                    alt="Student 3"
                                    className="student-image-3"
                                />
                            ) : (
                                <img src={topper3} alt="Empty" className="student-image-3" />
                            )}
                            <div className="score-box-right">
                                <div style={{ fontSize: "2rem", fontWeight: "bold" }}>
                                    {/* {student3?.student} - {student3?.score}% */}
                                    {`${student3?.student ?? "khushi"} - ${student3?.score ?? 85}%`}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="right-space"></div>

            {flgTopperSlideFormVisible && (
                <div className="slider1-80">
                    <TopperSliderForm
                        closeSlider={closeSlider}
                        classId={clsId}
                        sectionId={sectionId}
                        ptmId={ptmId}
                        examId={examId}
                        exam={exam}
                        classSection={`${cls} ${section}`}
                        topperRank={topperRank}
                        topperObj={topperObj}
                        updateKey={props.updateKey}
                    />
                </div>
            )}
        </div>
    );
}

export default TopperSlideComponent;
